import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import IdpValidator from './lib/IdpValidator'
import { ThemeProvider } from '@mui/material/styles'
import store from 'store/store'
import { NotificationProvider } from './components/providers/NotificationContext'
import AppRoutes from 'router/routes'
import RolesGate from 'components/permissions/rolesGate'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { caES } from '@mui/x-date-pickers/locales'
import 'dayjs/locale/ca'
import AppErrorBoundary from 'components/error/AppErrorBoundary'
import Layout from 'layouts/Layout'
import { StylesProvider } from '@consorciaoc-prj/eacat30_components'

function App() {
  return (
    <StylesProvider provider={ThemeProvider}>
      <Provider store={store}>
        <BrowserRouter basename={'/copia'}>
          <AppErrorBoundary>
            <IdpValidator>
              <NotificationProvider>
                <RolesGate>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale="ca"
                    localeText={caES.components.MuiLocalizationProvider.defaultProps.localeText}>
                    <Layout>
                      <AppRoutes />
                    </Layout>
                  </LocalizationProvider>
                </RolesGate>
              </NotificationProvider>
            </IdpValidator>
          </AppErrorBoundary>
        </BrowserRouter>
      </Provider>
    </StylesProvider>
  )
}

export default App
